import {isFeatureEnabled} from '@github-ui/feature-flags'
import {getIconColorClassName, getIconComponent} from '@github-ui/saved-views'
import {PinIcon} from '@primer/octicons-react'
import {Heading} from '@primer/react'

import type {PinControls} from '../../components/views/PinViewMenuItem'
import type {SavedView} from '../../components/views/types'
import {SavedViewActions} from './SavedViewActions'
import styles from './SavedViewHeader.module.css'

export function ViewHeaderIcon({icon: Icon, color}: {icon: ReturnType<typeof getIconComponent>; color: string}) {
  return <Icon size={16} className={`${styles.titleIcon} ${getIconColorClassName(color)}`} />
}

interface SavedViewHeaderProps {
  savedView: SavedView
  owner: string
  repo: string
  viewsPath: string
  onStartEditing: () => void
  canManage: boolean
  pinControls?: PinControls
}

export function SavedViewHeader({
  savedView,
  owner,
  repo,
  viewsPath,
  onStartEditing,
  canManage,
  pinControls,
}: SavedViewHeaderProps) {
  return (
    <div className={styles.titleWrapper}>
      <div className={styles.header}>
        <div className={styles.titleArea}>
          <ViewHeaderIcon icon={getIconComponent(savedView.icon)} color={savedView.color} />
          <Heading as="h1" className={styles.title}>
            {savedView.name}
          </Heading>
          {isFeatureEnabled('issue_pinned_views') && savedView.pinned && (
            <PinIcon size={16} data-testid="view-pinned-indicator" />
          )}
        </div>
        <SavedViewActions
          savedView={savedView}
          owner={owner}
          repo={repo}
          viewsPath={viewsPath}
          onStartEditing={onStartEditing}
          canManage={canManage}
          pinControls={pinControls}
        />
      </div>
      {savedView.description && <p className={styles.description}>{savedView.description}</p>}
    </div>
  )
}
